import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppText from "../components/app-text";
import ActualiteService from "../service/actualite.service";
import SearchForm from "../search-form";

const actualiteService = new ActualiteService();

export default function Actualites() {
  const [actualites, setActualites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lng, setLng] = useState(null);

  useEffect(() => {
    // Set language state from localStorage
    setLng(localStorage.getItem("lng"));
    
    actualiteService
      .getActiveActualites()
      .then((res) => {
        setActualites(res);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error loading news:", error);
        setLoading(false);
      });
  }, []);

  // Helper function to get title in current language
  const getActualiteTitle = (actualite) => {
    if (lng === null) return "";
    return actualite[`title_${lng}`] || actualite.title_fr || actualite.title_en || actualite.title_ar || `Actualité ${actualite.id}`;
  };

  // Helper function to get summary in current language
  const getActualiteSummary = (actualite) => {
    if (lng === null) return "";
    return actualite[`summary_${lng}`] || actualite.summary_fr || actualite.summary_en || actualite.summary_ar || "";
  };

  // Helper function to get content in current language
  const getActualiteContent = (actualite) => {
    if (lng === null) return "";
    return actualite[`content_${lng}`] || actualite.content_fr || actualite.content_en || actualite.content_ar || "";
  };

  if (loading || lng === null) {
    return (
      <div className="loading-container">
        <p><AppText cle="chargement" /></p>
      </div>
    );
  }

  return (
    <div>
      {/* Hero Section */}
      <section 
        className="hero-section" 
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('/assets/img/hero-actualites.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '400px',
          display: 'flex',
          alignItems: 'center',
          color: 'white'
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '20px' }}>
                <AppText cle="actualites_titre" section="sections_actualites" />
              </h1>
              <p style={{ fontSize: '1.4rem', maxWidth: '600px' }}>
                <AppText cle="actualites_sous_titre" section="sections_actualites" />
              </p>
            </div>
          </div>
          <SearchForm />
        </div>
      </section>

      {/* News Content */}
      <section className="actualites-content py-5">
        <div className="container my-5">
          {actualites.length === 0 ? (
            <div className="text-center">
              <h3><AppText cle="aucune_actualite" /></h3>
              <p><AppText cle="aucune_actualite_description" /></p>
            </div>
          ) : (
            <div className="row">
              {actualites.map((actualite) => (
                <div key={actualite.id} className="col-12 mb-5">
                  <div className="actualite-card">
                    <div className="row">
                      {/* Banner Column - 300x600px for internal page */}
                      <div className="col-md-4">
                        <div className="actualite-banner-container">
                          {actualite.banner_300x600 ? (
                            <img
                              src={actualite.banner_300x600}
                              alt={getActualiteTitle(actualite)}
                              className="actualite-banner"
                              style={{
                                width: "300px",
                                height: "600px",
                                objectFit: "cover",
                                borderRadius: "8px"
                              }}
                            />
                          ) : (
                            <div
                              className="actualite-banner-placeholder"
                              style={{
                                width: "300px",
                                height: "600px",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "8px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "2px dashed #dee2e6"
                              }}
                            >
                              <span style={{ color: "#6c757d" }}>Banner 300x600</span>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Content Column */}
                      <div className="col-md-8">
                        <div className="actualite-content p-4">
                          <h2 className="actualite-title mb-4">
                            {getActualiteTitle(actualite)}
                          </h2>
                          
                          {/* Summary if available */}
                          {getActualiteSummary(actualite) && (
                            <div className="actualite-summary mb-3">
                              <p style={{ fontSize: "1.2rem", fontWeight: "500", color: "#666", fontStyle: "italic" }}>
                                {getActualiteSummary(actualite)}
                              </p>
                            </div>
                          )}
                          
                          <div className="actualite-description">
                            <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
                              {getActualiteContent(actualite)}
                            </p>
                          </div>

                          {/* Date and Actions */}
                          <div className="actualite-meta mt-4">
                            <p className="text-muted mb-3">
                              <i className="bi bi-calendar3 me-2"></i>
                              {new Date(actualite.createdAt).toLocaleDateString('fr-FR')}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Separator */}
                  {actualite.id !== actualites[actualites.length - 1].id && (
                    <hr className="my-5" style={{ borderColor: "var(--primary-color)" }} />
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Back to Homepage Link */}
          <div className="text-center mt-5">
            <Link to="/" className="btn btn-secondary btn-lg">
              <i className="bi bi-house me-2"></i>
              <AppText cle="retour_accueil" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
} 